import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { Messages } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { TimeService } from '../time.service';
import { DateTime } from "luxon";

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  dialogData: any;
  dataToSend: any;
  messages = new Messages();
  reason: any = '';
  showReason = false;
  showDateTime = false;
  showLoader = false;
  other = false;
  reasons = [];
  arrived_at: any;
  finished_at: any;
  selectedReason = '';
  arrival = {
    date: '',
    time: '',
    date_time: ''
  }
  completion = {
    date: '',
    time: '',
    date_time: ''
  }
  constructor(private dialog: MatDialogRef<ConfirmationModalComponent>, @Inject(MAT_DIALOG_DATA) private parentData: any,
              private http: HttpService, private snackbar: SnackbarService, private translation: TranslateService,private timeService: TimeService) { }

  ngOnInit() {
    this.getReasons();
    this.dialogData = this.parentData;
    (this.dialogData.name == 'Complete Shipment') ? this.showReason = true : '';
    this.showDateTime = (this.dialogData.name == 'Complete Shipment') ? true : false;
  }

  setDateTime(value, type = '') {
    if (value.date && value.time) {
      const t1: any = this.timeService.getDateFromTime(value.time, 'hh:mm a');
      const t2: any = DateTime.fromJSDate(value.date).toFormat('dd/MM/yyyy');

      const epoch: any = DateTime.fromFormat(t2, 'dd/MM/yyyy').plus({ hours: t1.c.hour, minutes: t1.c.minute });
      value.date_time = epoch.ts;
      value.date = new Date(epoch.ts);
      if (type == 'arrived_at') {
        this.arrival.date = value.date;
        this.arrival.time = value.time;
        this.arrival.date_time = new Date(value.date_time).toISOString();
        this.arrived_at = value.date_time;
      } else if (type == 'finished_at') {
        this.completion.date = value.date;
        this.completion.time = value.time;
        this.completion.date_time = new Date(value.date_time).toISOString();
        this.finished_at = value.date_time;
      }
    }
  }

  confirm() {
    if (this.dialogData.name == 'Detach Vehicle') {
      this.dataToSend = {
        driver_id: this.dialogData.driver_id
      };
    } else if (this.dialogData.name == 'Attach Vehicle') {
      this.dataToSend = {
        driver_id: this.dialogData.driver_id,
        vehicle_id: this.dialogData.vehicle_id
      };
    } else if (this.dialogData.name == 'Detach Driver') {
      this.dataToSend = {
        driver_id: this.dialogData.driver_id
      };
    } else if (this.dialogData.name == 'Attach Driver') {
      console.log(this.dialogData);
      this.dataToSend = {
        driver_id: this.dialogData.driver_id,
        vehicle_id: this.dialogData.vehicle_id._id,
      };
    }else if (this.dialogData.type == 'delete_holiday') {
      this.dataToSend = this.dialogData.dataToSend;
      this.confirmDeleteHoliday();
    }else if (this.dialogData.name == 'Upload EPOD') {
      this.dataToSend = this.dialogData.dataToSend;
    } else if (this.dialogData.name == 'Upload Container & Seal #') {
      this.dataToSend = this.dialogData.dataToSend;
    } else if (this.dialogData.name == 'Complete Shipment') {
      if (!this.reason && !this.selectedReason) {
        this.snackbar.openSnackBar('Please fill the reason', '', 'err');
        return false;
      } else if (this.reason.length <= 3 && this.selectedReason.length <=3) {
        this.snackbar.openSnackBar(this.translation.instant('MESSAGE.CONFIRMATIONMODAL.SUCCESS.reason'), '', 'err');
        return false;
      }
      this.dataToSend = {
        id: this.dialogData.shipment_id,
        reason: this.other ? this.reason : this.selectedReason,
        arrived_at: this.arrived_at,
        finished_at: this.finished_at
      };
    }
    this.showLoader = true;
    if (this.dialogData.name == 'Complete Shipment') {
      if (!this.arrived_at) {
        this.snackbar.openSnackBar('Please select Arrival Time', '', 'err');
        return false;
      }
      if (this.arrived_at > this.finished_at) {
        this.snackbar.openSnackBar('Arrival Time cannot be greater than Comepletion Time', '', 'err');
        return false;
      }
      this.http.put(this.dialogData.url, this.dataToSend).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.showLoader = false;
            this.closeModal(data);
            this.snackbar.openSnackBar(this.messages.ORDER_DASHBOARD.SUCCESS.SHIPMENT_COMPLETED, '');
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.closeModal(err);
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else {
      this.http.upload(this.dialogData.url, this.dataToSend).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.showLoader = false;
            this.closeModal(data);
            if (this.dialogData.name == 'Detach Vehicle') {
              this.snackbar.openSnackBar(this.messages.CONFIRMATIONMODAL.SUCCESS.DETACH, '');
            } else if (this.dialogData.name == 'Attach Vehicle') {
              this.snackbar.openSnackBar(this.messages.CONFIRMATIONMODAL.SUCCESS.ATTACH, '');
            } else if (this.dialogData.name == 'Detach Driver') {
              this.snackbar.openSnackBar(this.messages.CONFIRMATIONMODAL.SUCCESS.DETACH, '');
            } else if (this.dialogData.name == 'Upload EPOD') {
              this.snackbar.openSnackBar(this.messages.CONFIRMATIONMODAL.SUCCESS.UPLOAD, '');
            } else if (this.dialogData.name == 'Upload Container & Seal #') {
              this.snackbar.openSnackBar(this.messages.CONFIRMATIONMODAL.SUCCESS.UPLOAD, '')
            }
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.closeModal(err);
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }

  confirmDeleteHoliday(){
    this.showLoader = true;
    this.http.post(this.dialogData.url, {holidays:this.dataToSend},3).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.CONFIRMATIONMODAL.SUCCESS.DELETE_HOLIDAY'), '');
          this.closeDialog(data);
        }
      },
      (err)=>{
        this.showLoader = false;
        this.closeDialog(err);
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  closeDialog(data) {
    this.dialog.close(data);
  }
  closeModal(type) {
    this.dialog.close(type);
  }
  getReasons() {
    this.http.get('constants/get_reasons?name=shipment').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.reasons = data.data[0].reason;
          this.reasons.push('Other');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  reasonChange(event, reason) {
    if (event.source._selected) {

      if (reason == 'Other') {
        this.other = true;
      } else {
        this.other = false;
      }
    }
  }
}
